// extracted by mini-css-extract-plugin
module.exports = {"alert":"alertMessage_alert__IDE4a","alertWrapper":"alertMessage_alertWrapper__3FZ0t","alertWrapperExtended":"alertMessage_alertWrapperExtended__HgeEu"};